import version from '../version';
export default "https://docucdn-a.akamaihd.net/olive/fonts/".concat(version);